import type { StaffMember } from '@jane/business-admin/types';

export const ROLE_LABEL_MAPPING = {
  client: 'Business Dashboard Manager',
  manager: 'Fulfillment Manager',
  staff_member: 'Fulfillment Staff',
};
const commonRoleOptions = [
  { label: ROLE_LABEL_MAPPING['client'], value: 'client' },
  { label: ROLE_LABEL_MAPPING['manager'], value: 'manager' },
  { label: ROLE_LABEL_MAPPING['staff_member'], value: 'staff_member' },
];

/**
 * auth_user = manager operating the page
 *
 * We want to show the list of roles based on the following criteria:
 * - if auth_user has edit_staff and edit_client_role permission, they should see all 3 roles
 * - if auth_user has only edit_staff and not edit_client_role permission, they should see only staff and manager
 * - if auth_user has only edit_client_role and not edit_staff permission, they should see only client
 *
 * No matter what the logged in user's permissions are, the dropdown should still display the staffmember's current role
 */

export const getRolesOptions = (
  userCanEditClient: boolean | undefined,
  userCanEditStaff: boolean | undefined,
  isCreateMode: boolean,
  staffMember: StaffMember | null
) => {
  const canEditClient = userCanEditClient !== false;
  const canEditStaff = userCanEditStaff !== false;
  const userCanEditAllRoles = canEditClient && canEditStaff;

  const filteredOptions = commonRoleOptions.filter((role) => {
    if (isCreateMode) {
      return (
        (canEditClient && role.value === 'client') ||
        (canEditStaff && role.value !== 'client')
      );
    } else {
      return (
        userCanEditAllRoles ||
        (canEditClient &&
          role.value === 'client' &&
          staffMember?.role === 'client') ||
        (canEditStaff &&
          role.value !== 'client' &&
          staffMember?.role !== 'client')
      );
    }
  });

  if (!filteredOptions.length)
    return commonRoleOptions.filter((role) => role.value === staffMember?.role);

  return filteredOptions;
};

export const shouldShowPermissions = (
  isCreateMode: boolean,
  staffMember: StaffMember | null,
  selectedRole: string,
  userCanEditClient: boolean | undefined
) => {
  if ((!isCreateMode && !staffMember?.permissions) || selectedRole !== 'client')
    return false;

  const canEditClient = userCanEditClient !== false;

  if (isCreateMode && canEditClient) return true;

  if (
    !isCreateMode &&
    (staffMember?.role === 'client' || selectedRole === 'client') &&
    canEditClient
  )
    return true;

  return false;
};

export const shouldShowDelete = (
  isCreateMode: boolean,
  staffMember: StaffMember | null,
  selectedRole: string,
  userCanEditClient: boolean | undefined,
  userCanEditStaff: boolean | undefined
) => {
  if (staffMember?.pushback_integration || isCreateMode) return false;

  if (
    (staffMember?.role === 'client' || selectedRole === 'client') &&
    userCanEditClient === false
  )
    return false;

  if (
    (staffMember?.role !== 'client' || selectedRole !== 'client') &&
    userCanEditStaff === false
  )
    return true;

  return true;
};
